class PromoCode extends HTMLElement {
  connectedCallback() {
    onLibReady(['vue'], this.#init.bind(this));
  }

  async #init() {
    const apiUrl = 'https://test1.allix.website/DriveBase/hs/ITrade';
    const fetchHeaders = {
      'Content-Type': 'application/json',
      Authorization: 'Basic d3NVc2VyMTU0NTpET3dnbVQ5MDEyNTRQa0ts',
    };

    new Vue({
      el: this,
      data: {
        step: 1,
        loading: false,
        order: null,
        error: null,
        timeLeft: 3,
        promoCode: null,
        email: null,
        rating: null,
        review: null,
        postalCode: null,
        gifts: [],
        gift: null,
        token: uuidv4(),
      },
      template: `
        <div class="page-width">
          <div class="promo-code">
            <form method="post" action="/contact" id="contact_form" accept-charset="UTF-8" class="contact-form">
              <input type="hidden" name="form_type" value="contact">
              <input type="hidden" name="utf8" value="✓">
              <input type="hidden" name="contact[Theme]" :value="step === 0 ? 'Promocode not founded' : 'Promocode'">
                  
              <template v-if="step === 0">
                <div class="promo-code__step promo-code__step-error" >
                  <p class="promo-code__step-title">
                    Oops, it seems there was an issue
                  </p>  
                  
                  <p class="promo-code__step-content">
                    Please try using a different promo code or contact us by sending an email to <a href="mailto:support@aldkitchen.com">support@aldkitchen.com</a> and include a picture of the voucher for further assistance 
                  </p>
                  
                  <input type="hidden" name="contact[promocode]" :value="promoCode">
                  
                  <div class="form-group large center">
                    <button class="button button--large button--orange" :class="{loading}" aria-label="Try another code">Try another code</button>
                  </div>
                </div>
              </template>   
              
              <template v-else>              
                <div class="promo-code__step promo-code__step-promo-code" v-if="step === 1 && !getQueryParams('code')">
                  <p class="promo-code__step-title">
                    Welcome to our exciting new promotion!
                  </p>  
                  
                  <div class="form-group center">
                    <p class="promo-code__step-title">Please input the Promo code</p>
                    <p class="promo-code__step-content">Enter the exclusive Promo code located on the back of your postcard</p>
                  </div>
                
                  <div class="form-group large">
                      <div class="pin-input-fields-container" ref="pinInputFields">
                        <input type="text" pattern="[0-9]*" class="form-control" maxlength="1" required data-index="0">
                        <input type="text" pattern="[0-9]*" class="form-control" maxlength="1" required data-index="1">
                        <input type="text" pattern="[0-9]*" class="form-control" maxlength="1" required data-index="2">
                        <div class="separator" />
                        <input type="text" pattern="[0-9]*" class="form-control" maxlength="1" required data-index="3">
                        <input type="text" pattern="[0-9]*" class="form-control" maxlength="1" required data-index="4">
                        <input type="text" pattern="[0-9]*" class="form-control" maxlength="1" required data-index="5">
                      </div>
                  </div>
              
                  <div class="form-group large center">
                    <button class="button button--large button--orange" :class="{loading}" @click.prevent="submitPromoCode" aria-label="Submit">Submit</button>
                  </div>
                </div>
                
                <div class="promo-code__step promo-code__step-email" v-if="step === 2">
                  <div>
                    <p class="promo-code__step-title capitalize" v-if="order?.Name">
                      Hello, {{order.Name}}
                    </p>  
                    
                    <p class="promo-code__step-sub-title">
                      Welcome to our exciting new promotion!
                    </p> 
                  </div>
                  
                  <div class="form-group center">
                    <p class="promo-code__step-title">You promo-code is</p>
                    <p class="promo-code__step-title promo-code__step-title-code">{{promoCode?.toString().replace(/(\\d{3})(\\d{3})/, '$1-$2')}}</p>
                  </div>
                  
                  <div class="form-group center">
                    <p class="promo-code__step-title">Please provide your Email</p>
                    <p class="promo-code__step-content">We may use it to confirm your delivery address</p>
                  </div>
                
                  <div class="form-group large">
                    <input
                        class="form-control"
                        type="email"
                        name="email"
                        v-model="email"
                        placeholder="name@mail.com"
                    >
                  </div>
              
                  <div class="form-group large center">
                    <button class="button button--large button--orange" :class="{loading}" @click.prevent="submitEmail" aria-label="Submit">Submit</button>
                  </div>
                </div>
                
                <div class="promo-code__step" v-if="step === 3">
                  <p class="promo-code__step-title">
                    Share your feedback for a {{order?.ProductName.split('|')[0].trim()}} you bought and get another item for free!
                  </p>
                
                  <div class="promo-code__step-rating">
                    <div class="form-group large center">
                      <p class="promo-code__step-title">Please share your experience</p>
                      <p class="promo-code__step-content">On a scale of satisfaction, how would you rate your recent purchase?</p>
                    </div>
                  
                    <div class="promo-code__step-img-wrap" v-if="order?.ImageUrl">
                      <img :src="order.ImageUrl" alt="">
                    </div>
                  
                    <div class="form-group large">
                      <div class="rating__stars">
                        <template v-for="i in [5, 4, 3, 2, 1]">
                          <input :id="'rating_' + i" type="radio" name="rating" :value="i" style="display: none;" v-model="rating" @change="setRating">
                          <label :for="'rating_' + i">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path
                                  d="M16.2003 19.9688C15.9507 19.9688 15.7011 19.844 15.4515 19.7192L9.96007 15.6006L4.46865 19.7192C3.96943
                            20.0936 3.47021 20.0936 2.97099 19.7192C2.47177 19.3448 2.34697 18.8456 2.59658 18.3463L4.96787
                            11.8565L0.474891 8.48674C0.100476 8.11232 -0.149134 7.6131 0.100476 7.11388C0.225281 6.61466
                            0.724501 6.24025 1.22372 6.24025H6.83994L8.71202 0.873635C8.96163 0.374415 9.46085 0 9.96007 0C10.4593 0
                            10.9585 0.374415 11.0833 0.873635L13.0802 6.24025H18.6964C19.1956 6.24025 19.6949 6.61466 19.8197
                            7.11388C19.9445 7.6131 19.8197 8.23713 19.4452 8.48674L15.0771 11.7317L17.4484 18.2215C17.5732 18.7208
                            17.4484 19.3448 17.074 19.5944C16.6995 19.844 16.4499 19.9688 16.2003 19.9688Z"
                                  fill="#E2BB6A"
                              />
                            </svg>
                          </label>
                        </template>
                      </div>
                    </div>
                    
                    <div class="form-group large center">
                      <p class="promo-code__step-content">
                        <template v-if="rating === 5">Perfection doesn't exist but im ejoid the product</template>
                        <template v-if="rating === 4">Major issues to be fixed</template>
                        <template v-if="rating === 3">A handful of fixes short of decent</template>
                        <template v-if="rating === 2">Close the product down</template>
                        <template v-if="rating === 1">Put the seller in jail imidiately</template>
                      </p>
                    </div>
                  </div>
                  
                  <div class="promo-code__step-review" v-show="rating">
                    <div class="form-group large center">
                      <p class="promo-code__step-title">
                        Please provide your feedback here
                      </p>
                      <p class="promo-code__step-content">
                        We kindly request a moment of your time to share your thoughts with us.
                        Your satisfaction is of utmost importance, and we truly value your valuable input.
                      </p>
                    </div>
      
                    <div class="form-group large">
                      <textarea
                        class="form-control"
                        rows="9"
                        cols="75"
                        name="review"
                        v-model="review"
                      ></textarea>
                    </div>
              
                    <div class="form-group large center">
                      <button class="button button--large button--orange" :class="{loading}" :disabled="!review" @click.prevent="submitReview" aria-label="Submit">Submit</button>
                    </div>
                  </div>
                </div>
                
                <div class="promo-code__step" v-if="step === 4">
                  <p class="promo-code__step-title">
                    Choose the product you would like to get as a gift
                  </p>
                  
                  <div class="promo-code__step-gifts">
                    <div class="form-group large center">
                      <p class="promo-code__step-title">Please choose your gift</p>
                    </div>
                    
                    <div class="form-group large">
                      <div class="gifts" v-if="gifts.length">
                        <div class="gift" v-for="(item, i) in gifts">
                          <input :id="'gift_' + i" type="radio" name="gift" :value="item" style="display: none;" v-model="gift" @change="submitGift">
                
                          <label class="gift" :for="'gift_' + i">
                            <img class="gift__img"
                              :srcset="item.GiftsUrl"
                              src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                              :alt="item.Gift"
                              loading="lazy"
                            >
                            
                            <div class="gift__name">
                              {{item.GiftsName}}
                            </div>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div class="promo-code__step" v-if="step === 5">
                  <p class="promo-code__step-title">
                    Thank you for your review!
                  </p>
                  
                  <p class="promo-code__step-content">
                    Please publish your review to submit request
                  </p>
                  
                  <div class="promo-code__step-final">
                    <div class="promo-code__step-img-wrap" v-if="order?.ImageUrl">
                      <img :src="order.ImageUrl" alt="">
                    </div>
                  
                    <div class="form-group large">
                      <div class="rating__stars">
                        <template v-for="i in [5, 4, 3, 2, 1]">
                          <input type="radio" :value="i" style="display: none;" :checked="i === rating" disabled>
                          <label>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path
                                  d="M16.2003 19.9688C15.9507 19.9688 15.7011 19.844 15.4515 19.7192L9.96007 15.6006L4.46865 19.7192C3.96943
                            20.0936 3.47021 20.0936 2.97099 19.7192C2.47177 19.3448 2.34697 18.8456 2.59658 18.3463L4.96787
                            11.8565L0.474891 8.48674C0.100476 8.11232 -0.149134 7.6131 0.100476 7.11388C0.225281 6.61466
                            0.724501 6.24025 1.22372 6.24025H6.83994L8.71202 0.873635C8.96163 0.374415 9.46085 0 9.96007 0C10.4593 0
                            10.9585 0.374415 11.0833 0.873635L13.0802 6.24025H18.6964C19.1956 6.24025 19.6949 6.61466 19.8197
                            7.11388C19.9445 7.6131 19.8197 8.23713 19.4452 8.48674L15.0771 11.7317L17.4484 18.2215C17.5732 18.7208
                            17.4484 19.3448 17.074 19.5944C16.6995 19.844 16.4499 19.9688 16.2003 19.9688Z"
                                  fill="#E2BB6A"
                              />
                            </svg>
                          </label>
                        </template>
                      </div>
                    </div>
                    
                    <div class="form-group large">
                      <textarea
                        class="form-control"
                        rows="9"
                        cols="75"
                        :value="review"
                        disabled
                      ></textarea>
                    </div>
              
                    <div class="form-group large center">
                      <button class="button button--accent button--outline" @click.prevent="textareaCopyText" aria-label="Copy text">
                        <svg class="icon icon-bag" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M6.515 4.75a2 2 0 0 1 1.985-1.75h3a2 2 0 0 1 1.985 1.75h.265a2.25 2.25 0 0 1 2.25 2.25v7.75a2.25 2.25 0 0 1-2.25 2.25h-7.5a2.25 2.25 0 0 1-2.25-2.25v-7.75a2.25 2.25 0 0 1 2.25-2.25h.265Zm1.985-.25h3a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5Zm-1.987 1.73.002.02h-.265a.75.75 0 0 0-.75.75v7.75c0 .414.336.75.75.75h7.5a.75.75 0 0 0 .75-.75v-7.75a.75.75 0 0 0-.75-.75h-.265a2 2 0 0 1-1.985 1.75h-3a2 2 0 0 1-1.987-1.77Z"/></svg>
                        <span>Copy text to clipboard</span>
                      </button>
                    </div>
                    
                    <div class="form-group large center" v-if="timeLeft > 0">
                      <p class="promo-code__step-content">
                        <span>You will be automatically redirected to the review page in seconds.</span>
                        <span class="promo-code__step-timer">{{ timeLeft }}</span>
                      </p>
                    </div>
                    
                    <div class="form-group large center" v-if="timeLeft <= 0">
                      <a :href="this.order?.Link" target="_blank" rel="noreferrer" class="button button--accent button--outline">
                        Open page manually
                      </a>
                    </div>
                  </div>
                </div>
                
                <div class="center" v-if="error">
                  <div class="alert-error" v-html="error" />
                </div>
              </template>    
            </form>
          </div>  
        </div>
      `,

      beforeMount() {
        if (getQueryParams('code')) {
          this.promoCode = getQueryParams('code');
          this.submitPromoCode();
        }
      },

      mounted() {
        if (this.$refs.pinInputFields) {
          const nums = this.$refs.pinInputFields.querySelectorAll('input');

          nums.forEach(num => {
            num.addEventListener('keyup', () => {
              let code = '';

              if (num.value === '' || /^\d+$/.test(num.value)) {
                if (num.value.length === 1) {
                  nums[parseInt(num.dataset.index) + 1]?.focus();
                } else {
                  nums[parseInt(num.dataset.index) - 1]?.focus();
                }
              } else {
                num.value = '';
              }

              nums.forEach(num => {
                code += num.value;
              });

              this.promoCode = code;
            });
          });
        }
      },

      methods: {
        nextStep() {
          setTimeout(() => {
            window.scrollTo({
              top: 0,
              behavior: 'smooth',
            });
          });

          this.step++;
        },

        async submitPromoCode() {
          if (this.promoCode) {
            this.error = '';
            this.order = await this.fetchOrder();

            if (this.order) {
              this.nextStep();
              this.setLocationData();
            } else {
              this.error = `
                <p style="color: orange">We're sorry, but it seems the promo code ${this.promoCode?.toString().replace(/(\d{3})(\d{3})/, '$1-$2')} is either not found or has expired.</p> 
                <p style="color: orange">Please reach out to us at <a href="mailto:support@aldkitchen.com" style="color: blue; text-decoration: underline !important;">support@aldkitchen.com</a> to resolve this issue.</p>
              `;
            }
          } else {
            this.error = 'Enter promo code!';
          }
        },

        submitEmail() {
          this.update('email', () => {
            this.order?.Variant ? this.nextStep() : (this.step = 0);
          });
        },

        setRating() {
          const reviewBlock = document.querySelector('.promo-code__view-review');
          if (reviewBlock) {
            reviewBlock.scrollIntoView({behavior: 'smooth'});
          }
        },

        submitReview() {
          this.update('review', async () => {
            this.order = await this.fetchOrderWithParams();
            this.gifts = this.order.GiftsList;
            this.nextStep();
          });
        },

        submitGift() {
          this.update('gift', async () => {
            if (this.order.Link) {
              this.order.Link = await this.getShortUrl(this.order.Link);

              this.nextStep();
              this.textareaCopyText();

              const downloadTimer = setInterval(() => {
                if (this.timeLeft <= 0) {
                  clearInterval(downloadTimer);
                  window.open(this.order.Link, '_blank');
                } else {
                  this.timeLeft -= 1;
                }
              }, 1000);
            } else {
              this.step = 0;
            }
          });
        },

        async update(field, callback) {
          const fields = {
            email: {
              fieldName: 'Email',
              errorText: 'Incorrect email!',
            },
            review: {
              fieldName: 'ReviewText',
              errorText: 'No review left!',
            },
            gift: {
              fieldName: 'Gifts',
              errorText: 'No gift selected!',
            },
          };

          const fieldValue = this[field];
          const {fieldName, errorText} = fields[field];

          if (field === 'review' && (!this.rating || !this.review)) {
            this.error = errorText;
            return;
          }

          if (!fieldValue || (field === 'email' && !this.validateEmail(fieldValue))) {
            this.error = errorText;
            return;
          }

          this.error = '';

          const data = {};

          if (field === 'gift') {
            data['Gift'] = this.gift.GiftsName;
            data['GiftsName'] = this.gift.GiftsName;
            data['GiftsUrl'] = this.gift.GiftsUrl;
          } else if (field === 'review') {
            data['Review'] = this.rating;
            data['ReviewText'] = this.review;
          } else {
            data[fieldName] = fieldValue;
          }

          const response = await this.updateOrder(data);

          if (response.errors) {
            this.error = response.errors;
          } else {
            typeof callback === 'function' && callback();
          }
        },

        async fetchOrder() {
          this.loading = true;

          const response = await fetch(`${apiUrl}/GetDataByPIN?PIN=${this.promoCode}&Token=${this.token}`, {
            headers: fetchHeaders,
          })
            .then(response => response.json())
            .then(response => (response.Orders?.length ? response.Orders[0] : null))
            .catch(() => null);

          this.loading = false;

          return response;
        },

        async fetchOrderWithParams() {
          this.loading = true;

          const response = await fetch(
            `${apiUrl}/GetDataByPIN?PIN=${this.promoCode}&ZIPIP=${this.postalCode}&Review=${this.rating}&ShowGiftList=True&Token=${this.token}`,
            {
              headers: fetchHeaders,
            },
          )
            .then(response => response.json())
            .then(response => (response.Orders?.length ? response.Orders[0] : null))
            .catch(() => null);

          this.loading = false;

          return response;
        },

        async updateOrder(data) {
          this.loading = true;
          const error = {errors: 'An error has occurred!'};

          data.Token = this.token;

          const response = await fetch(`${apiUrl}/SetTrackingNumberAttributs?PIN=${this.promoCode}`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: fetchHeaders,
          })
            .then(response => response.json())
            .then(data => (data.Errors ? error : data))
            .catch(() => error);

          this.loading = false;

          return response;
        },

        // Only this page needs MaxMind - for the postal code, which Shopify's
        // country lookup doesn't give - so it is loaded here rather than with
        // the theme-wide vendors in optimization.js.
        loadGeoip() {
          if (window.geoip2) return Promise.resolve(window.geoip2);

          return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = 'https://js.maxmind.com/js/apis/geoip2/v2.1/geoip2.js';
            script.async = true;
            script.addEventListener('load', () => resolve(window.geoip2));
            script.addEventListener('error', () => reject(new Error('Failed to load the MaxMind geoip2 script')));
            document.body.appendChild(script);
          });
        },

        async setLocationData() {
          try {
            const geoip = await this.loadGeoip();

            geoip.city(
              response => {
                const postalCode = response.postal?.code;
                const ip = response.traits?.ip_address;

                if (postalCode) {
                  this.postalCode = postalCode;
                  fetch(
                    `${apiUrl}/SetZipByIPForTracking?PIN=${this.promoCode}&ZipByIP=${postalCode}&Token=${this.token}`,
                    {
                      headers: fetchHeaders,
                    },
                  );
                }

                if (ip) {
                  this.updateOrder({IP: ip});
                }
              },
              error => console.warn('MaxMind city lookup failed:', error),
            );
          } catch (error) {
            console.warn(error);
          }
        },

        validateEmail(email) {
          return /^[\w-+\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email);
        },

        textareaCopyText() {
          const textarea = document.createElement('textarea');
          textarea.value = this.review;
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand('copy');
          document.body.removeChild(textarea);
        },

        async getShortUrl(url) {
          try {
            const response = await fetch(
              `https://ald-custom.digitaluniverse.app/api/short-url?url=${url}&prefix=${this.promoCode}`,
              {signal: AbortSignal.timeout(3000)},
            ).then(response => response.json());

            return response.success ? response.url : url;
          } catch (error) {
            return url;
          }
        },
      },
    });
  }
}

customElements.define('promo-code', PromoCode);
